import styled from 'styled-components';

export const Hr1Styled = styled.hr`
  background-color: ${props => props.theme.hr1Color};
  border: 0 none;
  height: 0.1rem;
  margin: 2rem 0;
`;

export const Hr2Styled = styled.hr`
  background-color: ${props => props.theme.hr1Color};
  border: 0 none;
  height: 0.1rem;
  margin: 1rem 0 0;
`;



// WEBPACK FOOTER //
// ./styles/components/hr.style.js